"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnsweredQuestionnaire {
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getToken() {
        return this.token;
    }
    setToken(token) {
        this.token = token;
        return this;
    }
    hasAnswers() {
        return !!this.getAnsweredQuestions().getArray().length;
    }
    getAnsweredQuestions() {
        return this.answeredQuestions;
    }
    getAnsweredQuestion(id) {
        return this.getAnsweredQuestions().find((question) => question.getId() === id);
    }
    setAnsweredQuestions(questions) {
        this.answeredQuestions = questions;
        return this;
    }
}
exports.default = AnsweredQuestionnaire;
